export const BASE_URL = "https://api.panchgavyaretails.com/api/";
export const IMAGE_URL = "https://api.panchgavyaretails.com/uploads";

export const REACT_APP_API_BASE_URL = BASE_URL;
export const REACT_APP_API_IMAGE_URL = IMAGE_URL;
